import { useEffect, useState } from 'react'
import Form from 'react-bootstrap/Form';

export default function TextBoxNumericControl(props) {

    const [value, setValue] = useState(props.value);

    function onChange(value) {
        setValue(value);
        if (props.onChange)
            props.onChange(value)
    }

    function onBlur(value) {
        setValue(value);
        if (props.onBlur)
            props.onBlur(value)
    }

    function onKeyPress(event) {
        if (event.which < 48 || event.which > 57) {
            event.preventDefault();
        }
    }

    function setNewValue(value) {
        setValue(value);
    }

    return (
        <div>
            <Form.Group className="mb-3">
                {props.title != null &&
                    <Form.Label>{props.title}<span class="text-danger fw-bold"> {props.required && '*'}</span> </Form.Label>
                }
                <Form.Control
                    type="text"
                    ref={props.inputRef}
                    value={value}
                    className={props.className}
                    valid={props.valid}
                    required={props.required}
                    maxlength={props.maxlength ? props.maxlength : '-1'}
                    onChange={(e) => onChange(e.target.value)}
                    onBlur={(e) => onBlur(e.target.value)}
                    onKeyPress={onKeyPress}
                    onKeyDown={props.onKeyDown}
                    placeholder={props.placeholder}
                    disabled={props.disabled ? true : false}
                />
            </Form.Group>
        </div>
    )
}